import cx from 'classnames'
import styles from './StatusChip.module.css'

export type StatusChipVariant =
  | 'success'
  | 'info'
  | 'danger'
  | 'warning'
  | 'neutral'
  | 'muted'

export interface StatusChipProps {
  /** The text label to display */
  label: string
  /** The semantic colour variant */
  variant?: StatusChipVariant
  /** Size of the badge */
  size?: 'small' | 'medium'
  /** Additional CSS class */
  className?: string
}

export function StatusChip({
  label,
  variant = 'neutral',
  size,
  className,
}: StatusChipProps) {
  return (
    <span
      className={cx(styles.StatusChip, className, {
        [styles.isVariantSuccess]: variant === 'success',
        [styles.isVariantInfo]: variant === 'info',
        [styles.isVariantDanger]: variant === 'danger',
        [styles.isVariantWarning]: variant === 'warning',
        [styles.isVariantNeutral]: variant === 'neutral',
        [styles.isVariantMuted]: variant === 'muted',
        [styles.isSizeSmall]: size === 'small',
      })}
    >
      {label}
    </span>
  )
}
